import type { ReactNode } from "react";

type ToolSectionHeaderProps = {
  title: string;
  description?: string;
  headingId: string;
  children?: ReactNode;
};

export default function ToolSectionHeader({
  title,
  description,
  headingId,
  children,
}: ToolSectionHeaderProps) {
  return (
    <div className="text-center space-y-3">
      <h2
        id={headingId}
        className="text-2xl md:text-3xl font-bold text-[#5b32b4]"
      >
        {title}
      </h2>
      {description ? (
        <p className="text-gray-500 text-sm max-w-xl mx-auto">{description}</p>
      ) : null}
      {children}
    </div>
  );
}
